import * as Factory from 'factory.ts'
import faker from 'faker'

import { type IntegrationConstructor } from './Integration'
import { EntitySyncConfigurationConstructorFactory } from '../EntitySyncConfiguration/stubs'

export const IntegrationConstructorFactory =
  Factory.Sync.makeFactory<IntegrationConstructor>({
    id: Factory.each(() => faker.random.uuid()),
    name: 'urn:integration:backend:merge:quickbooks-online',
    status: 'ACTIVE',
    entitySyncConfigurations: Factory.each(() => [
      EntitySyncConfigurationConstructorFactory.build(),
    ]),
  })
